import axois from "axios";
import { BaseApiService } from "./api-base";

export class OmaApiService extends BaseApiService {
  constructor(host: string) {
    super("oma");
    this.http = axois.create({
      baseURL: host,
    });
    this.http.interceptors.request.use((config) => {
      config.headers.Authorization = this.jwt;
      return config;
    });
  }
}
